import baustein from "baustein";
import userProfiler from "web/script/modules/userprofiler";
import analytics from "web/script/analytics/analytics";
import facebookEvents from "web/script/analytics/facebook-events";
import browser from "web/script/utils/browser";
import { showDataSurvey } from "web/script/components/data-survey";
import { languageIsEnglish } from "web/script/modules/language";

import "web/script/components/email-capture-prompt";
import "web/script/components/image-gallery";
import "web/script/components/oos-product-hero";
import "web/script/components/overlays/generic-overlay-launcher";
import "web/script/components/recently-viewed";
import "web/script/components/related-from-retailer";

const AFFILIATE_BUY_BUTTON_SELECTOR = ".monoprice-buy-area__buy-button--affiliate";

let buyButtonClicked = false;

export default baustein.register("product-page", {
    defaultOptions: {
        viewSimilar: false,
    },

    setupEvents(add) {
        add("click", AFFILIATE_BUY_BUTTON_SELECTOR, this._onBuyButtonClick);
    },

    _onBuyButtonClick(event) {
        if (event.ctrlKey || event.shiftKey || event.metaKey || event.which == 2) {
            return;
        } else {
            buyButtonClicked = true;
        }
    },

    init() {
        const product = this.options.product;

        if (!product) {
            return;
        }

        // Save the seen product in the
        // user localstorage profile
        userProfiler.saveSeenProduct(product);

        analytics.tagEvent(analytics.TAG_NETWORKS.FACEBOOK, facebookEvents.VIEW_CONTENT, {
            content_ids: [product.product_id],
            content_type: "product",
        });

        if (
            this.options.features &&
            this.options.features.show_data_survey &&
            languageIsEnglish()
        ) {
            const seenProductsCount = userProfiler.getSeenProducts().length;
            const surveyShown = userProfiler.getSurveyShown();
            if (!surveyShown && seenProductsCount >= 3) {
                this.setupDataSurveyListener();
            }
        }
    },

    setupDataSurveyListener() {
        const buyOption = this.options.buyoption;
        if (!buyOption) {
            return;
        }
        const retailerName = buyOption.retailer_name;
        browser.addVisibilityListener(function(isVisible) {
            if (!isVisible || !buyButtonClicked) {
                return;
            }
            showDataSurvey(retailerName);
        });
    },

    /**
     * Called by the route handlers, so that this component can be treated
     * the same way as a product-overlay component.
     */
    close() {
        return this.destroy();
    },
});
